<script>
  import { format } from 'svelte-i18n';
  import {
    Alert,
    Button,
    ButtonDropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Tooltip
  } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

  export let steps = [];
  export let store = {};
  export let tourHeader = 'label.TOUR.DEFAULT_ALERT_HEADER';
  export let tourDescription = 'label.TOUR.DEFAULT_DESCRIPTION';
  export let marginBottom = 'mb-3';
  export let marginTop = 'mt-4';

  let isOpen = true;

  const startTour = (steps) => {
    GLOBAL_DRIVER_OBJECT.setSteps(steps);
    GLOBAL_DRIVER_OBJECT.drive();
  };

  const onDismissAlert = () => {
    isOpen = false;

    setTimeout(() => {
      $store.tours.isDismissed = true;
    }, 400);
  };

  $: fullSteps = steps.find((step) => step.stepsKey === 'full')?.steps;

  $: alertSteps = $store?.tours?.hasData ? fullSteps : steps.find((step) => step.stepsKey === 'default')?.steps;

  $: dismissedOrToured = $store?.tours?.isDismissed || $store?.tours?.hasToured;
</script>

{#if dismissedOrToured}
  <ButtonDropdown class="tour-dropdown hide--mobile">
    <DropdownToggle class="tour-toggle" color="link" caret>{$format('label.TOUR.TAKE_TOUR')}</DropdownToggle>
    <DropdownMenu>
      {#each steps.slice(0, -1) as tour}
        <DropdownItem on:click={() => startTour(tour.steps)} disabled={tour.disabled}>
          <div class="tour-item">
            <div class="icon" class:hasToured={$store.tours[tour.storeKey]}>
              {#if $store.tours[tour.storeKey]}
                <Icon name="check" class="text-white text-small" />
              {/if}
            </div>
            <slot>
              {@html $format(tour.menuLabel)}
            </slot>
          </div>
        </DropdownItem>
      {/each}
      <DropdownItem divider />
      <DropdownItem id="tooltip-start-tour" on:click={() => startTour(fullSteps)} disabled={!$store.tours.hasData}>
        {$format('label.TOUR.FULL_TOUR')}
      </DropdownItem>
      <Tooltip placement="left" target="tooltip-start-tour">{@html $format(tourDescription)}</Tooltip>
    </DropdownMenu>
  </ButtonDropdown>

  <div class="action-divider hide--mobile"></div>
{:else}
  <Alert class="tour-alert-wrapper {marginTop} {marginBottom} hide--mobile" color="light" transition="400" bind:isOpen>
    <div class="tour-alert">
      <div class="tour-info">
        <h4>{$format(tourHeader)}</h4>
        <div>
          <slot>
            {@html $format(tourDescription)}
          </slot>
          <Button class="dismiss-btn" size="sm" color="link" on:click={onDismissAlert}
            >{$format('label.DISMISS')}</Button
          >
        </div>
      </div>
      <div class="start-tour">
        <Button color="primary" on:click={() => startTour(alertSteps)}>
          {$format('label.TOUR.START_TOUR')}
        </Button>
      </div>
    </div>
  </Alert>
{/if}

<style lang="scss" src="./tour.scss"></style>
